import Page from '@modul-connect/shared/components/atoms/page'
import { H3, H4 } from '@modul-connect/shared/components/atoms/text'
import View from '@modul-connect/shared/components/atoms/view'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { fetchUser, moveUser } from '../../../../../state/actions/customers'
import { fetchWorkshop, fetchWorkshopV2 } from '../../../../../state/actions/workshops'
import TreeWidget from '@modul-connect/shared/components/molecules/treeWidget'
import { useAuth0 } from '@auth0/auth0-react';
import { ThreeDots } from 'react-loader-spinner'
import theme from '@modul-connect/shared/theme'

const Roles = {
  vanCheck: 'van check',
  standard: 'standard',
  admin: 'admin',
  super: 'super',
  tester: 'tester'
}

function translateRole(role) {
  switch(role) {
    case Roles.standard:
      return 'a technician, with no access to the backoffice.'
    case Roles.vanCheck:
      return 'a van check technician, with limited access to the modul-connect system.'
    case Roles.admin:
      return 'an admin, with access to their workshop in backoffice.'
    case Roles.super:
      return 'a superadmin, with access to to everything in backoffice.'
    case Roles.tester:
      return 'a tester, with BLE-only access for box setup tests.'
    default:
      return 'a user, but not related to this workshop.'
  }
}

export const Technician = ({
  email, workhshopId, workshop, user, fetchWorkshop, fetchUser, moveUser, loading
}) => {
  const auth = useAuth0()

  const navigate = useNavigate()

  const [role, setRole] = useState(undefined)

  const isLoading = loading?.fetchUser?.[email] === 'loading'
  const loadingFailed = loading?.fetchUser?.[email] === 'failed'

  useEffect(() => {
    if (workshop.tree?.uuid !== workhshopId)
      fetchWorkshop(workhshopId)
  }, [workhshopId])

  useEffect(() => {
    if (user.email !== email && !isLoading)
      fetchUser(email)
  }, [email])

  useEffect(() => {
    const currentRole = user.user_metadata?.info.tags.find(x => x.tags === workhshopId)?.privilege
    if (currentRole) setRole(currentRole)
  }, [user])

  useEffect(() => {
    const currentRole = user.user_metadata?.info.tags.find(x => x.tags === workhshopId)?.privilege
    if (currentRole && role && role !== currentRole)
      moveUser({ email, organisation: workhshopId, privilege: role })
  }, [role])

  const isYou = auth.user?.email === email

  return (
    user.email !== email || workshop.tree?.uuid !== workhshopId
    ?
    <View extend={ styles.loaderContainer }>
       <ThreeDots
              color={ theme.colors.primary }
              height={30}
              width={30}
        />
      <H3>Fetching technicians ...</H3>
    </View>
    :
    <Page title={ workshop.name + ': ' + user.firstName + ' ' + user.lastName + (isYou ? ' (your account)' : '')} linkBack={ navigate }>
      {/* <H3>{ (isYou ? 'You are ' : user.firstName + ' is ') + translateRole(role) }</H3> */}
      { isYou ? 
        <H4>Making changes to your own account is prohibited. You assigned as {translateRole(role)}</H4> :
        <TreeWidget
          hideRoot
          title={ 'Role'}
          tree={{
              uuid: 1, name: 'Role', 
              children: [
                {uuid: Roles.vanCheck, name: 'Van Check (limited access to modul-connect system)'},
                  {uuid: Roles.standard, name: 'Standard (cannot access backoffice)'},
                  {uuid: Roles.admin, name: 'Admin (can access their workshop in backoffice)'},
                  {uuid: Roles.super, name: 'Super (can access everything in backoffice)'},
                  {uuid: Roles.tester, name: 'Tester (BLE-only setup tests)'}
              ]
          }}
          onSelect={ (uuid, _) => uuid !== 1 && setRole(uuid) }
          selected={ role }
          disabled={ isYou }
        />
    
      }
    </Page>
  )
}

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  padding_style: {
    marginRight: 80,
    width: 350
  },
  padding: {
    marginBottom: '40px'
  },
  loaderContainer: {
    height: '70vh',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  }
}

const mapStateToProps = ({
  workshop,
  user,
  loading
}) => ({
  workshop,
  user,
  loading
})

const mapDispatchToProps = dispatch => ({
  fetchWorkshop: workshopId => dispatch(fetchWorkshopV2(workshopId)),
  fetchUser: email => dispatch(fetchUser(email)),
  moveUser: data => dispatch(moveUser(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Technician)
